import React, { useRef, useEffect, useState } from 'react';
import SingleSelectDropdown from 'containers/NewCreativePreview/components/Filter Modal/singleSelectDropdown';
import * as S from '../../../../PodHomePage/components/Screen/components/OnDemandModal/style';
import MultiSelectDropdown, {
  Option,
} from '../../Filter Modal/multiSelectDropdown';
import { useGetWebTesterMetadataMutation } from 'services/api/creativeServer';

interface MosaicFormProps {
  destinationURL: string;
  onDestinationURLChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  selectedDestinationType: Option | null;
  onDestinationTypeChange: (value: Option | null) => void;
  selectedAdslot: Option;
  setIsOpen: (value: boolean) => void;
  onOSVersionChange: (value: Option[] | null) => void;
  country: Option | null;
  onCountryChange: (value: Option | null) => void;
  osv: Option[] | null;
}

export const WebTesterForm: React.FC<MosaicFormProps> = ({
  destinationURL,
  onDestinationURLChange,
  selectedDestinationType,
  onDestinationTypeChange,
  selectedAdslot,
  onOSVersionChange,
  country,
  onCountryChange,
  osv,
  setIsOpen,
}) => {
  const destinationTypeOptions: Option[] = [
    { key: 'Web', value: 'Web', label: 'Web' } as Option,
    { key: 'WebFS', value: 'WebFS', label: 'WebFS' } as Option,
  ];
  const [getWebTesterMetadata, { isLoading }] =
    useGetWebTesterMetadataMutation();
  const scrollRef = useRef<HTMLDivElement>(null);

  const [countryOptions, setCountryOptions] = useState<Option[]>([]);
  const [osvOptions, setOsvOptions] = useState<Option[]>([]);

  useEffect(() => {
    const fetchMetadata = async () => {
      try {
        const response = await getWebTesterMetadata({}).unwrap();

        setCountryOptions(
          response.countries.map(item => ({
            key: item,
            value: item,
            label: item,
          })),
        );

        setOsvOptions(
          response.osVersions.map(item => ({
            key: item,
            value: item,
            label: item,
          })),
        );
      } catch (err) {
        console.error('Failed to fetch web tester metadata:', err);
      }
    };

    fetchMetadata();
  }, []);

  const filterOptions = (options: Option[], inputValue: string) => {
    if (!inputValue) return options;
    return options.filter(item =>
      item.label.toLowerCase().includes(inputValue.toLowerCase()),
    );
  };

  return (
    <S.UploadSection ref={scrollRef}>
      <S.AssetLabel>Test Website URL across multiple OS versions</S.AssetLabel>
      <S.SubText>
        Provide Website URL, then select Destination Type, Country and OS
        versions
      </S.SubText>
      <S.FormSection ref={scrollRef}>
        <S.FormRow>
          <S.FormGroup>
            <S.Label>Destination Type</S.Label>
            <div style={{ fontSize: 13, width:'30%' }}>
              <SingleSelectDropdown
                placeholder="Select..."
                value={selectedDestinationType}
                onChange={onDestinationTypeChange}
                loadOptions={inputValue =>
                  Promise.resolve(
                    filterOptions(destinationTypeOptions, inputValue),
                  )
                }
                defaultOptions={destinationTypeOptions}
                isLoading={false}
                setIsOpen={setIsOpen}
              />
            </div>
          </S.FormGroup>
        </S.FormRow>

        <S.FormRow>
          <S.FormGroup>
            <S.Label>Website URL</S.Label>
            <S.Input
              value={destinationURL}
              onChange={onDestinationURLChange}
              style={{ width: '90%' }}
            />
          </S.FormGroup>
        </S.FormRow>

        <S.FormRow>
          <S.FormGroup>
            <S.Label>Country</S.Label>
            <div style={{ fontSize: 13 }}>
              <SingleSelectDropdown
                placeholder="Select..."
                value={country}
                onChange={onCountryChange}
                loadOptions={inputValue =>
                  Promise.resolve(filterOptions(countryOptions, inputValue))
                }
                defaultOptions={countryOptions}
                isLoading={isLoading}
                setIsOpen={setIsOpen}
              />
            </div>
          </S.FormGroup>

          <S.FormGroup>
            <S.Label>OS Version</S.Label>
            <div style={{ fontSize: 13 }}>
              <MultiSelectDropdown
                placeholder="Select..."
                value={osv}
                onChange={onOSVersionChange}
                loadOptions={inputValue =>
                  Promise.resolve(filterOptions(osvOptions, inputValue))
                }
                defaultOptions={osvOptions}
                isLoading={isLoading}
                setIsOpen={setIsOpen}
                disabled={false}
              />
            </div>
          </S.FormGroup>
        </S.FormRow>
      </S.FormSection>
    </S.UploadSection>
  );
};
